import { render, staticRenderFns } from "./DeclarationListItem.vue?vue&type=template&id=62c5bcaa&scoped=true&"
import script from "./DeclarationListItem.vue?vue&type=script&lang=ts&"
export * from "./DeclarationListItem.vue?vue&type=script&lang=ts&"
import style0 from "./DeclarationListItem.vue?vue&type=style&index=0&id=62c5bcaa&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62c5bcaa",
  null
  
)

export default component.exports